// Types
type IconProps = {
  size?: number;
  className?: string;
};

/**
 * LinkedIn icon - used for social sharing
 */
export const LinkedInIcon = ({ size = 24, className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M25.667 0H2.333A2.333 2.333 0 000 2.333v23.334A2.333 2.333 0 002.333 28h23.334A2.333 2.333 0 0028 25.667V2.333A2.333 2.333 0 0025.667 0zM8.4 23.8H4.2V10.5h4.2v13.3zM6.3 8.633a2.45 2.45 0 110-4.9 2.45 2.45 0 010 4.9zM23.8 23.8h-4.2v-6.475c0-1.54-.028-3.524-2.147-3.524-2.149 0-2.479 1.68-2.479 3.413V23.8H10.8V10.5h4.025v1.817h.056c.56-1.063 1.93-2.184 3.974-2.184 4.253 0 5.04 2.8 5.04 6.44V23.8h-.095z" />
  </svg>
);

